import { comparisonData } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function ComparisonTable() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1100px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            Platform Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3">
            Compare Spreadsheet Platforms
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-xl mx-auto">
            See how <strong>Hipobuy Spreadsheet</strong> compares against other popular spreadsheet research platforms for product discovery.
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-xl border border-background-200/70">
          <table className="w-full">
            <thead>
              <tr className="bg-background-200/40">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800">Platform</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800">Spreadsheet Resource</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800">Best For</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800">Learning Curve</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr
                  key={row.platform}
                  className={`border-t border-background-200/50 ${
                    index === 0 ? "bg-primary-50/60" : "bg-background-50"
                  }`}
                >
                  <td className="px-6 py-4 text-sm font-semibold text-foreground-900">
                    {row.platform}
                    {index === 0 && (
                      <span className="ml-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-full">
                        Recommended
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-sm text-foreground-600">{row.resource}</td>
                  <td className="px-6 py-4 text-sm text-foreground-600">{row.bestFor}</td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center gap-1.5 text-sm font-medium ${
                      row.curve === "Easy" ? "text-accent-600" : "text-secondary-600"
                    }`}>
                      <span className={`w-2 h-2 rounded-full ${
                        row.curve === "Easy" ? "bg-accent-500" : "bg-secondary-500"
                      }`}></span>
                      {row.curve}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col gap-4">
          {comparisonData.map((row, index) => (
            <div
              key={row.platform}
              className={`p-5 rounded-xl border ${
                index === 0
                  ? "bg-primary-50/60 border-primary-200"
                  : "bg-background-50 border-background-200/70"
              }`}
            >
              <div className="flex items-center gap-2 mb-3">
                <h3 className="text-base font-semibold text-foreground-950">{row.platform}</h3>
                {index === 0 && (
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-full">
                    Recommended
                  </span>
                )}
              </div>
              <div className="flex flex-col gap-1.5 text-sm text-foreground-600">
                <p><span className="font-medium text-foreground-800">Resource:</span> {row.resource}</p>
                <p><span className="font-medium text-foreground-800">Best For:</span> {row.bestFor}</p>
                <p>
                  <span className="font-medium text-foreground-800">Learning Curve:</span>{" "}
                  <span className={row.curve === "Easy" ? "text-accent-600" : "text-secondary-600"}>
                    {row.curve}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/kakobuy-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            Read detailed platform comparisons
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}